import { render, staticRenderFns } from "./DocumentosTab.vue?vue&type=template&id=a5bfd3d0"
import script from "./DocumentosTab.vue?vue&type=script&lang=js"
export * from "./DocumentosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports